import { formatWeekDayDateTime, userDate } from 'owa-datetime';
import { InfoBarOptionsAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import loc, { format } from 'owa-localize';
import { approveLabel } from 'owa-locstrings/lib/strings/approvelabel.locstring.json';
import { rejectLabel } from 'owa-locstrings/lib/strings/rejectlabel.locstring.json';
import { ClientMessage } from 'owa-mail-store';
import LastAction from 'owa-mail-types/lib/types/LastAction';
import { createVotingInfoBarMessage } from 'owa-mail-voting';
import {
    infoApprovalRequestPleaseRespond,
    infoApprovalRequestDecision,
    infoVotingRequestResponse,
} from './createMessageApprovalAndVotingInfoBarMessage.locstring.json';
import {
    getUserLastActionForMessageItem,
    getUserLastActionTimeForMessageItem,
} from '../utils/getUserLastActionInfoBarUtils';

export default function createMessageApprovalAndVotingInfoBarMessage(
    message: ClientMessage
): (string | InfoBarOptionsAction)[] {
    const votingInformation = message.VotingInformation;

    if (votingInformation) {
        const votingOptionsCount = votingInformation.UserOptions?.length;

        if (votingOptionsCount == 2 && message.ApprovalRequestData) {
            const approvalRequestData = message.ApprovalRequestData;

            if (approvalRequestData.IsUndecidedApprovalRequest) {
                return [loc(infoApprovalRequestPleaseRespond)];
            } else if (
                approvalRequestData.ApprovalDecision &&
                approvalRequestData.ApprovalDecisionMaker &&
                approvalRequestData.ApprovalDecisionTime
            ) {
                const decisionText =
                    approvalRequestData.ApprovalDecision == LastAction.VotingOptionMin
                        ? loc(approveLabel)
                        : loc(rejectLabel);
                const formattedDateTime = formatWeekDayDateTime(
                    userDate(approvalRequestData.ApprovalDecisionTime)
                );
                return [
                    format(
                        loc(infoApprovalRequestDecision),
                        approvalRequestData.ApprovalDecisionMaker,
                        decisionText,
                        formattedDateTime
                    ),
                ];
            }
        } else if (votingOptionsCount > 0) {
            const votingInfoBarMessage = createVotingInfoBarMessage(
                message,
                getUserLastActionForMessageItem,
                getUserLastActionTimeForMessageItem
            );
            return votingInfoBarMessage ? [votingInfoBarMessage] : [];
        } else if (!votingOptionsCount && votingInformation.VotingResponse) {
            // The sender has responded {decision}
            return [format(loc(infoVotingRequestResponse), votingInformation.VotingResponse)];
        }
    }

    return [];
}
